import React from 'react';
import { compose, withHandlers, defaultProps } from 'recompose';
import cx from 'classnames';
import withField from '../withField';

import styles from './styles.css';

export type Props = {
  disabled?: boolean;
  error?: string;
  labels?: string[];
  value?: boolean;
  defaultValue?: boolean;
  onChange?: (FormEvent) => void;
  onClick?: (FormEvent) => void;
  theme?: 'default' | 'rounded' | 'dark';
  position?: 'rtl' | 'ltr';
  style?: any;
  isLoading?: boolean;
  name?: string;
  register?: any;
};

export type OwnProps = Props & {
  theme: string;
  size: string;
  iconBefore: JSX.Element | undefined;
  iconAfter: JSX.Element | undefined;
  onKeyPress?: () => void;
  position: 'rtl' | 'ltr';
};

export const Switch = compose<OwnProps, Props>(
  defaultProps({ position: 'rtl', theme: 'default' }),
  withHandlers({
    onChange:
      ({ onPush, onChange, disabled }) =>
      (e) => {
        if (!disabled && onPush) onPush(!e.target.checked);
        return onChange(e.target.checked);
      },
  })
)(
  ({
    onChange,
    onClick,
    value,
    defaultValue,
    disabled,
    labels,
    label,
    isLoading,
    position,
    style,
    theme,
    register = {},
  }) => (
    <div
      style={style}
      className={cx(
        styles.root,
        isLoading && styles.isLoading,
        styles[`theme-${theme}`]
      )}
    >
      <label>
        <input
          type="checkbox"
          className={styles.input}
          disabled={disabled}
          onChange={onChange}
          onClick={onClick}
          checked={value}
          defaultChecked={defaultValue}
          {...register}
        />
        <div className={cx(styles.content, styles[position])}>
          {theme === 'rounded' ? (
            <span className={styles.circle}>
              <span className={styles.checkbox} />
            </span>
          ) : (
            <span className={styles.checkbox} />
          )}
          {label && (
            <div className={styles.labels}>
              <span className={cx(styles.label, styles.static)}>{label}</span>
            </div>
          )}
          {labels && (
            <div className={styles.labels}>
              <span className={cx(styles.label, styles.active)}>
                {labels[0]}
              </span>
              <span className={cx(styles.label, styles.inactive)}>
                {labels[1] || labels[0]}
              </span>
            </div>
          )}
        </div>
      </label>
    </div>
  )
);

export default withField(Switch);
